import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';

export const withRouterListener = WrapperComponent => props => {
  const [callback, setCallback] = useState({ function: null });
  const location = useLocation();
  const action = useNavigationType();
  const navigate = useNavigate();

  const history = {
    listen: callback => {
      setCallback({ function: callback });
    },
    unlisten: () => setCallback({ function: null }),
    navigate,
  };

  useEffect(
    () => {
      callback.function && callback.function(location, action);
    },
    [action, location, callback.function],
  );

  return <WrapperComponent {...props} {...{ history }} />;
};
